import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { staggerContainer, itemVariants } from '../utils/animations';
const testimonials = [{
  name: 'Carlos Rodríguez',
  business: 'Clínica Dental Rodríguez',
  location: 'Montevideo',
  metric: '⏱ Entregada en 72 horas',
  quote: '"Pasamos de depender únicamente de Instagram a tener una web profesional donde nuestros pacientes pueden encontrarnos fácilmente. Todo estuvo listo en pocos días."',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=90&w=200'
}, {
  name: 'Valentina S.',
  business: 'Restaurante La Toscana',
  location: 'Punta del Este',
  metric: '📱 Más consultas por WhatsApp',
  quote: '"La web nos ayudó a mostrar mejor nuestro menú y recibir más consultas directas. El proceso fue rápido y el resultado superó nuestras expectativas."',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=90&w=200'
}, {
  name: 'Diego M.',
  business: 'Hotel Boutique',
  location: 'Colonia',
  metric: '🏨 Reservas directas',
  quote: '"Dejamos de depender tanto de las plataformas y sus comisiones. Ahora tenemos una web que enamora a los huéspedes antes de llegar."',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=90&w=200'
}];
export function Testimonials() {
  return <section className="py-20 md:py-32 relative" data-id="element-355">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-356">
        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-357">
          {testimonials.map((test, idx) => <motion.div key={idx} variants={itemVariants} className="p-6 sm:p-8 rounded-2xl bg-white/[0.02] border border-white/5 flex flex-col justify-between" data-id="element-358">
              <div data-id="element-359">
                <div className="flex items-center justify-between mb-6" data-id="element-360">
                  <div className="flex space-x-1" data-id="element-361">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} className="text-neon fill-neon drop-shadow-[0_0_5px_rgba(59,130,246,0.5)]" data-id="element-362" />)}
                  </div>
                  <div className="text-[10px] font-medium text-neutral-400 bg-white/5 px-2 py-1 rounded border border-white/5" data-id="element-363">
                    {test.metric}
                  </div>
                </div>
                <p className="text-base text-neutral-300 font-light leading-relaxed mb-8" data-id="element-364">
                  {test.quote}
                </p>
              </div>
              <div className="flex items-center space-x-4 pt-4 border-t border-white/5" data-id="element-365">
                <img src={test.avatar} alt={test.name} className="w-10 h-10 rounded-full object-cover ring-2 ring-white/10 shadow-md" loading="lazy" data-id="element-366" />
                <div data-id="element-367">
                  <div className="text-white font-medium text-sm" data-id="element-368">
                    {test.name}
                  </div>
                  <div className="text-neutral-400 text-xs" data-id="element-369">
                    {test.business}
                  </div>
                  <div className="text-neutral-500 text-[10px] mt-0.5" data-id="element-370">
                    📍 {test.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}